// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.output_outerContainer__7b0cJ {
  display: flex;
  align-items: center;
  justify-content: center;
}

.output_container__GqLWf {
  width: 727px;
  min-width: 727px;
  height: 135px;
  background-color: #ffffff;
  box-shadow:
    rgba(0, 0, 0, 8%) 0 8px 13px -2px,
    rgba(27, 41, 74, 0.29) 0 17px 4px -14px;
  border-radius: 9px;
  display: flex;
  position: relative;
  cursor: pointer;
}

.output_status__4mT9X {
  font-family: Poppins, sans-serif;
  font-weight: 600;
  color: #ffffff;
  background-color: #5fc43b;
  border-top-left-radius: 9px;
  border-bottom-left-radius: 9px;
  height: 100%;
  width: 52px;
  min-width: 52px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  transition:
    background-color 0.3s ease,
    color 0.3s ease;
  position: relative;
}

.output_statusOff__KzGcU {
  background-color: #a9a9a9;
}

.output_verticalDivider__Av6FX {
  background-color: rgb(205, 205, 205);
  height: 80%;
  width: 2px;
  border-radius: 50%;
}

.output_resetButton__189mV {
  vertical-align: middle;
  text-align: center;
  background-color: #d53c3c;
  font-weight: 600;
  font-size: 14px;
  border-bottom-left-radius: 9px;
  width: 100%;
  padding: 8px 0;
  height: 100%;
}

.output_portPopup__zSdV9 {
  background-color: #fff;
  width: 200px;
  height: 100px;
  position: absolute;
  z-index: 100000;
  border-radius: 10px;
  box-shadow: #1a2026cc 0 0 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.output_port__7EIGA {
  background-color: #3ba810;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  position: absolute;
  top: 0;
}

.output_nickname__0xrMY {
  background-color: rgba(136, 211, 110, 0.3);
  color: #429c23;
  position: absolute;
  top: 0;
  left: 0;
  font-size: 14px;
  padding: 0 3px;
  font-weight: 600;
  border-bottom-right-radius: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/components/output/output.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB;;2CAEyC;EACzC,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,2BAA2B;EAC3B,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB;;mBAEiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,8BAA8B;EAC9B,WAAW;EACX,cAAc;EACd,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,+BAA+B;AACjC","sourcesContent":[".outerContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.container {\n  width: 727px;\n  min-width: 727px;\n  height: 135px;\n  background-color: #ffffff;\n  box-shadow:\n    rgba(0, 0, 0, 8%) 0 8px 13px -2px,\n    rgba(27, 41, 74, 0.29) 0 17px 4px -14px;\n  border-radius: 9px;\n  display: flex;\n  position: relative;\n  cursor: pointer;\n}\n\n.status {\n  font-family: Poppins, sans-serif;\n  font-weight: 600;\n  color: #ffffff;\n  background-color: #5fc43b;\n  border-top-left-radius: 9px;\n  border-bottom-left-radius: 9px;\n  height: 100%;\n  width: 52px;\n  min-width: 52px;\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  transition:\n    background-color 0.3s ease,\n    color 0.3s ease;\n  position: relative;\n}\n\n.statusOff {\n  background-color: #a9a9a9;\n}\n\n.verticalDivider {\n  background-color: rgb(205, 205, 205);\n  height: 80%;\n  width: 2px;\n  border-radius: 50%;\n}\n\n.resetButton {\n  vertical-align: middle;\n  text-align: center;\n  background-color: #d53c3c;\n  font-weight: 600;\n  font-size: 14px;\n  border-bottom-left-radius: 9px;\n  width: 100%;\n  padding: 8px 0;\n  height: 100%;\n}\n\n.portPopup {\n  background-color: #fff;\n  width: 200px;\n  height: 100px;\n  position: absolute;\n  z-index: 100000;\n  border-radius: 10px;\n  box-shadow: #1a2026cc 0 0 8px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.port {\n  background-color: #3ba810;\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  position: absolute;\n  top: 0;\n}\n\n.nickname {\n  background-color: rgba(136, 211, 110, 0.3);\n  color: #429c23;\n  position: absolute;\n  top: 0;\n  left: 0;\n  font-size: 14px;\n  padding: 0 3px;\n  font-weight: 600;\n  border-bottom-right-radius: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"outerContainer": `output_outerContainer__7b0cJ`,
	"container": `output_container__GqLWf`,
	"status": `output_status__4mT9X`,
	"statusOff": `output_statusOff__KzGcU`,
	"verticalDivider": `output_verticalDivider__Av6FX`,
	"resetButton": `output_resetButton__189mV`,
	"portPopup": `output_portPopup__zSdV9`,
	"port": `output_port__7EIGA`,
	"nickname": `output_nickname__0xrMY`
};
export default ___CSS_LOADER_EXPORT___;
